module.exports = __webpack_public_path__ + "static/media/martin-knize.90cb0947.jpg";